				//LARA_CUMKITTEN, HANNASECRET, MARYWET, BETTIEBALLHAUS, AISCHE_PERVERS
const ACTOR_IDS = [5120401, 11339736, 7532515, 11213224, 1582031];

function isActorSeoTest(actorId) {
	return ACTOR_IDS.includes(actorId);
}


export {
	isActorSeoTest
};
